/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import {
  createCoupon,
  deleteCoupon,
  listCoupon,
  updateCoupon,
  viewCoupon,
} from "./_requests";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";
import Select from "react-select";
import DeleteModal from "../../Components/Common/DeleteModal";
import ReactQuill from "react-quill";

const Coupon = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [coupons, setCoupons] = useState<any>([]);
  const [couponAccess, setCouponAccess] = useState<any>([]);
  const { userProfile } = useProfile();
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [couponToDeleteId, setCouponToDeleteId] = useState<string>("");
  const [couponToDeleteCode, setCouponToDeleteCode] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");
  const navigate = useNavigate();

  const amountTypeOptions = [
    { value: 1, label: "Fixed Amount" },
    { value: 2, label: "Percentage" }
  ];

  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
  }, [modal]);

  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = () => {
    listCoupon().then((res: any) => {
      setCoupons(res.data);
    });
  };

  // Delete Data
  const onClickDelete = useCallback(
    (coupon: any) => {
      setCouponToDeleteCode(coupon.code);
      setCouponToDeleteId(coupon.id);
      toggleDeleteModal();
    },
    [toggleDeleteModal]
  );

  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      code: "",
      product_id: null,
      amount_type: 1,
      minimum_order_value: 0,
      usage_count: 1,
      coupon_value: 0,
      start_date: "",
      end_date: "",
      is_active: true,
      description: "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Coupon code is required"),
      amount_type: Yup.number().required("Amount type is required"),
      minimum_order_value: Yup.number()
        .required("Minimum order value is required")
        .min(0, "Must be positive"),
      usage_count: Yup.number()
        .required("Usage count is required")
        .min(1, "Must be at least 1"),
      coupon_value: Yup.number()
        .required("Coupon value is required")
        .min(0, "Must be positive"),
      start_date: Yup.date().required("Start date is required"),
      end_date: Yup.date()
        .required("End date is required")
        .min(Yup.ref('start_date'), "End date must be after start date"),
      description: Yup.string(),
    }),
    onSubmit: async (values: any) => {
      try {
        const couponData = {
          ...values,
          [isEdit ? "updated_by" : "created_by"]: userProfile?.userId,
          start_date: new Date(values.start_date),
          end_date: new Date(values.end_date)
        };

        if (isEdit) {
          await updateCoupon(couponData, values.id);
          toast.success("Coupon updated successfully", { autoClose: 3000 });
        } else {
          await createCoupon(couponData);
          toast.success("Coupon created successfully", { autoClose: 3000 });
        }

        fetchCoupons();
        validation.resetForm();
        toggle();
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong", { autoClose: 3000 });
      }
    },
  });
  console.log("validation.values.is_active", validation.values.is_active)
  const confirmDelete = async (couponId: any) => {
    await deleteCoupon(couponId, userProfile?.userId);
    toggleDeleteModal();
    toast.success("Coupon deleted successfully", { autoClose: 3000 });
    fetchCoupons();
  };

  // Update Data
  const handleCouponClick = useCallback(
    async (coupon: any) => {
      const couponData = await viewCoupon(coupon.id);
      console.log("couponData", couponData)
      validation.setValues({
        id: coupon.id,
        code: couponData?.code || "",
        product_id: couponData?.product_id || null,
        amount_type: couponData?.amount_type || 1,
        minimum_order_value: couponData?.minimum_order_value || 0,
        usage_count: couponData?.usage_count || 1,
        coupon_value: couponData?.coupon_value || 0,
        start_date: couponData?.start_date ? new Date(couponData.start_date).toISOString().split('T')[0] : "",
        end_date: couponData?.end_date ? new Date(couponData.end_date).toISOString().split('T')[0] : "",
        is_active: couponData?.is_active != undefined ? couponData.is_active : true,
        description: couponData?.description || "",

      });
      setIsEdit(true);
      toggle();
    },
    [toggle, validation]
  );

  const handleView = (row: any) => {
    navigate(`/coupon/view/${row.id}`, { state: { couponDetailsView: row } });
  };

  // Coupons Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Code",
        accessorKey: "code",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to={`/coupon/view/${cell.row.original.id}`}
            state={{ couponDetailsView: cell.row.original }}
            className="text-primary fw-medium"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "Value",
        accessorKey: "coupon_value",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span>
            {cell.row.original.amount_type === 1
              ? `₹${cell.getValue()}`
              : `${cell.getValue()}%`}
          </span>
        ),
      },
      {
        header: "Min Order",
        accessorKey: "minimum_order_value",
        enableColumnFilter: false,
        cell: (cell: any) => `₹${cell.getValue()}`
      },
      {
        header: "Usage Limit",
        accessorKey: "usage_count",
        enableColumnFilter: false,
      },
      {
        header: "Active",
        accessorKey: "is_active",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span className={`badge ${cell.getValue() ? 'bg-success' : 'bg-danger'}`}>
            {cell.getValue() ? 'Active' : 'Inactive'}
          </span>
        ),
      },
      {
        header: "Action",
        cell: (cellProps: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={() => {
                    const couponData = cellProps.row.original;
                    handleCouponClick(couponData);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const couponData = cellProps.row.original;
                    onClickDelete(couponData);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleCouponClick, onClickDelete]
  );

  const addCoupon = () => {
    setIsEdit(false);
    toggle();
    validation.resetForm();
  };

  document.title = "Admin panel | Coupons";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Coupons" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card id="couponList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Coupon List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        <button
                          type="button"
                          className="btn text-white add-btn me-1"
                          style={{
                            backgroundColor: "#28a8df",
                            borderColor: "#28a8df",
                          }}
                          id="create-btn"
                          onClick={addCoupon}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add Coupon
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <div>
                    <TableContainer
                      columns={columns}
                      data={coupons || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      SearchPlaceholder="Search coupons..."
                    />
                  </div>

                  <Modal id="showModal" isOpen={modal} toggle={toggle} centered size="lg" className="coupon-modal">
                    <ModalHeader className="bg-light p-3 d-flex align-items-center" toggle={toggle}>
                      <i className={`me-2 ${!!isEdit ? "ri-pencil-line" : "ri-coupon-line"}`}></i>
                      {!!isEdit ? "Edit Coupon" : "Add Coupon"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e: any) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />

                        <div className="row g-3">
                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="code-field" className="form-label">
                                Coupon Code <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ri-coupon-2-line"></i>
                                </span>
                                <Input
                                  name="code"
                                  id="code-field"
                                  className="form-control"
                                  placeholder="e.g. SUMMER20"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.code || ""}
                                  invalid={
                                    validation.touched.code && validation.errors.code
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.code && validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label className="form-label d-block">
                                Amount Type <span className="text-danger">*</span>
                              </Label>
                              <div className="btn-group w-100" role="group">
                                <button
                                  type="button"
                                  className={`btn ${validation.values.amount_type === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                  onClick={() => validation.setFieldValue("amount_type", 1)}
                                >
                                  <i className="ri-currency-inr-line me-1"></i> ₹ Fixed Amount
                                </button>
                                <button
                                  type="button"
                                  className={`btn ${validation.values.amount_type === 2 ? 'btn-primary' : 'btn-outline-primary'}`}
                                  onClick={() => validation.setFieldValue("amount_type", 2)}
                                >
                                  <i className="ri-percent-line me-1"></i> Percentage
                                </button>
                              </div>
                              {validation.touched.amount_type && validation.errors.amount_type ? (
                                <div className="text-danger mt-1" style={{ fontSize: '0.875em' }}>
                                  {validation.errors.amount_type}
                                </div>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="coupon-value-field" className="form-label">
                                Coupon Value <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  {validation.values.amount_type === 2 ? '%' : '₹'}
                                </span>
                                <Input
                                  name="coupon_value"
                                  id="coupon-value-field"
                                  className="form-control"
                                  placeholder={validation.values.amount_type === 2 ? "0-100" : "Enter amount"}
                                  type="number"
                                  min={validation.values.amount_type === 2 ? 0 : undefined}
                                  max={validation.values.amount_type === 2 ? 100 : undefined}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.coupon_value || ""}
                                  invalid={
                                    validation.touched.coupon_value && validation.errors.coupon_value
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.coupon_value && validation.errors.coupon_value ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.coupon_value}
                                </FormFeedback>
                              ) : null}
                              <small className="text-muted">
                                {validation.values.amount_type === 2
                                  ? "Enter discount percentage (e.g. 20 for 20%)"
                                  : "Enter fixed discount amount"}
                              </small>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="min-order-field" className="form-label">
                                Minimum Order <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">₹</span>
                                <Input
                                  name="minimum_order_value"
                                  id="min-order-field"
                                  className="form-control"
                                  placeholder="0.00"
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.minimum_order_value || ""}
                                  invalid={
                                    validation.touched.minimum_order_value && validation.errors.minimum_order_value
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.minimum_order_value && validation.errors.minimum_order_value ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.minimum_order_value}
                                </FormFeedback>
                              ) : null}
                              <small className="text-muted">Minimum cart value to apply this coupon</small>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="usage-count-field" className="form-label">
                                Usage Limit <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ri-user-line"></i>
                                </span>
                                <Input
                                  name="usage_count"
                                  id="usage-count-field"
                                  className="form-control"
                                  placeholder="0 for unlimited"
                                  type="number"
                                  min="0"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.usage_count || ""}
                                  invalid={
                                    validation.touched.usage_count && validation.errors.usage_count
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.usage_count && validation.errors.usage_count ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.usage_count}
                                </FormFeedback>
                              ) : null}
                              <small className="text-muted">Maximum number of times this coupon can be used</small>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="start-date-field" className="form-label">
                                Start Date <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ri-calendar-line"></i>
                                </span>
                                <Input
                                  name="start_date"
                                  id="start-date-field"
                                  className="form-control"
                                  type="date"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.start_date || ""}
                                  invalid={
                                    validation.touched.start_date && validation.errors.start_date
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.start_date && validation.errors.start_date ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.start_date}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="end-date-field" className="form-label">
                                End Date <span className="text-danger">*</span>
                              </Label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="ri-calendar-line"></i>
                                </span>
                                <Input
                                  name="end_date"
                                  id="end-date-field"
                                  className="form-control"
                                  type="date"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.end_date || ""}
                                  min={validation.values.start_date}
                                  invalid={
                                    validation.touched.end_date && validation.errors.end_date
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.end_date && validation.errors.end_date ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.end_date}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="mb-3">
                              <Label htmlFor="is-active-field" className="form-label d-block">
                                Status
                              </Label>
                              <div className="form-check form-switch form-switch-lg">
                                <Input
                                  name="is_active"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="is-active-field"
                                  checked={validation.values.is_active}
                                  onChange={(e) =>
                                    validation.setFieldValue("is_active", e.target.checked)
                                  }
                                />
                                <Label check htmlFor="is-active-field" className="form-check-label">
                                  {validation.values.is_active ? (
                                    <span className="text-success">
                                      <i className="ri-checkbox-circle-fill me-1"></i> Active
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      <i className="ri-close-circle-fill me-1"></i> Inactive
                                    </span>
                                  )}
                                </Label>
                              </div>
                              <small className="text-muted">Toggle to enable/disable this coupon</small>
                            </div>
                          </Col>

                          <Col md={12}>
                            <div className="mb-3">
                              <Label htmlFor="description-field" className="form-label">
                                Description
                              </Label>
                              <div className="rich-text-editor border rounded-3">
                                <ReactQuill
                                  theme="snow"
                                  value={validation.values.description}
                                  onChange={(value: any) => validation.setFieldValue("description", value)}
                                  placeholder="Enter coupon details and terms..."
                                  modules={{
                                    toolbar: [
                                      ['bold', 'italic', 'underline', 'strike'],
                                      ['blockquote', 'code-block'],
                                      [{ 'header': 1 }, { 'header': 2 }],
                                      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                      [{ 'script': 'sub' }, { 'script': 'super' }],
                                      [{ 'indent': '-1' }, { 'indent': '+1' }],
                                      [{ 'direction': 'rtl' }],
                                      [{ 'size': ['small', false, 'large', 'huge'] }],
                                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                      [{ 'color': [] }, { 'background': [] }],
                                      [{ 'font': [] }],
                                      [{ 'align': [] }],
                                      ['clean'],
                                      ['link', 'image']
                                    ],
                                  }}
                                  formats={[
                                    'header', 'font', 'size',
                                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                                    'list', 'bullet', 'indent',
                                    'link', 'image', 'color', 'background', 'align'
                                  ]}
                                />
                              </div>
                              <small className="text-muted">Describe the coupon benefits and any restrictions</small>
                            </div>
                          </Col>

                        </div>
                      </ModalBody>
                      <ModalFooter className="border-top">
                        <div className="d-flex justify-content-end w-100">

                          <div>
                            <button
                              type="button"
                              className="btn btn-light me-2"
                              onClick={toggle}
                            >
                              <i className="ri-close-line me-1"></i> Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={Duplicate}
                            >
                              <i className={`me-1 ${!!isEdit ? "ri-save-line" : "ri-add-line"}`}></i>
                              {!!isEdit ? "Update Coupon" : "Create Coupon"}
                            </button>
                          </div>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>
          <DeleteModal
            show={deleteModalOpen}
            onDeleteClick={() => confirmDelete(couponToDeleteId)}
            onCloseClick={toggleDeleteModal}
            content={
              <>
                Do you want to delete coupon <strong>{couponToDeleteCode}</strong>?
              </>
            }
          />

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Coupon;